import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios-interceptor";

export function useForecastQuery(type?: string): {
  data?: types.ForecastInfo;
  error: Error | null;
  isLoading: boolean;
} {
  const isEnabled = !!type;

  const { data, error, isLoading } = useQuery<types.ForecastInfo>({
    queryKey: ["forecast", type],
    queryFn: async () => {
      const res = await api.get<types.ForecastInfo>(`/v1/forecast/${type}`);
      return res.data;
    },
    enabled: isEnabled,
    placeholderData: (prevData) => prevData,
  });

  return {
    data,
    error: error as Error | null,
    isLoading,
  };
}

export function useFore3hourQuery(): {
  data?: types.Fore3Hour[];
  error: Error | null;
  isLoading: boolean;
} {
  const { data, error, isLoading } = useQuery<types.Fore3Hour[]>({
    queryKey: ["fore3hour"],
    queryFn: async () => {
      const res = await api.get<types.Fore3Hour[]>(`/v1/fore3hour`);
      return res.data;
    },
  });

  return {
    data,
    error: error as Error | null,
    isLoading,
  };
}
